import Thanks from '@sunbit-dev/ui/src/components/card-apply/pages/thanks/Thanks';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectInitialDetails } from '../selectors';
import { useMixpanel } from '../services/mixpanel/mixPanel';
import { MixpanelCardApplylEvent } from '@sunbit-dev/common/enums/cardApply/MixpanelCardApplylEvent';

const ThanksContainer: React.FC = () => {
  const initialDetails = useSelector(selectInitialDetails);
  const { trackForMixPanel } = useMixpanel();
  React.useEffect(() => {
    trackForMixPanel(MixpanelCardApplylEvent.SuccessPage_Views);
  }, [trackForMixPanel]);
  return <Thanks firstName={initialDetails.customerFirstName || ''} />;
};

export default ThanksContainer;
